module.exports = __webpack_public_path__ + "static/img/wealth_level_75.14bffcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_75.png
// module id = 5CQn
// module chunks = 0